import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import BrushIcon from '@mui/icons-material/Brush';
import copy from 'copy-to-clipboard';
import React, { Fragment, useState } from 'react';
import { IKeyword, KEYWORDS } from './utils';
import { useAutocomplete } from '@mui/base/AutocompleteUnstyled';

const ITEM_HEIGHT = 48;

export interface IKeywordInjector {
  inputId: string;
}
function KeyWordSelector(props: IKeywordInjector & {onSelect: (keyword: IKeyword) => void}) {
  const {inputId, onSelect} = props;
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions
  } = useAutocomplete({
    id: `${inputId}-autocomplete`,
    options: KEYWORDS,
    getOptionLabel: (e: IKeyword) => e.example,
    freeSolo: false,
    open: true,
    clearOnBlur: false
  });

  return (
    <Grid container direction="column" {...getRootProps()}>
      <TextField
        placeholder="Select Keyword"
        variant="outlined"
        fullWidth
        autoFocus
        InputLabelProps={{
          ...getInputLabelProps()
        }}
        {...getInputProps() as any}
      />
      {groupedOptions.length > 0 &&
      <List
        dense
        disablePadding
        {...getListboxProps()}

      >
        {(groupedOptions as any)
          .map((option: any, index: number) =>
            <ListItem
              {...getOptionProps({ option, index })}
              key={option.id}
            >
              <ListItemButton
                onClick={(event: React.MouseEvent) => {
                  onSelect(option);
                }}
              >
              <ListItemText
                id={option.id}
                primary={option.name}
                secondary={option.example}
                secondaryTypographyProps={{ style: { fontSize: 10 } }}
              />
              </ListItemButton>
            </ListItem>
          )}
      </List>
      }
    </Grid>
  )
}

export default function KeywordInjector(props: IKeywordInjector) {
  const { inputId } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [copiedText, setCopiedText] = useState('');
  const [open, setOpen] = useState(false);

  const handleSelect = (keyword: IKeyword) => {
    copy(keyword.id);
    setCopiedText(keyword.id);
    setAnchorEl(null);
    setOpen(true);
  }

  return (
    <Fragment>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open} autoHideDuration={1000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity="info">
           Copied to clipboard
        </Alert>
      </Snackbar>

      <IconButton size="small" style={{opacity: 0.7}} onClick={(event: any) => setAnchorEl(event.target)}><BrushIcon/></IconButton>

      <Popover
        id={`${inputId}-popover`}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5
            // width: '20ch',
          }
        }}
        keepMounted
      >
        <KeyWordSelector inputId={inputId} onSelect={handleSelect}/>
      </Popover>

      {/*<Menu*/}
      {/*  id={`${inputId}-keyword-selector`}*/}
      {/*  anchorEl={anchorEl}*/}
      {/*  keepMounted*/}
      {/*  onClose={() => setAnchorEl(null)}*/}
      {/*  open={!!anchorEl}*/}
      {/*  PaperProps={{*/}
      {/*    style: {*/}
      {/*      maxHeight: ITEM_HEIGHT * 4.5*/}
      {/*      // width: '20ch',*/}
      {/*    }*/}
      {/*  }}*/}
      {/*>*/}
      {/*  */}
      {/*  {groupedOptions.map((keyword: IKeyword) =>*/}
      {/*    <CopyToClipboard*/}
      {/*      key={keyword.id}*/}
      {/*      text={keyword.id}*/}
      {/*      onCopy={() => setCopiedText(keyword.id)}*/}
      {/*    >*/}
      {/*    <MenuItem onClick={() => handleSelect(keyword)}>*/}
      {/*      <Grid container direction="column" justifyContent="space-between">*/}
      {/*        <Grid item>*/}
      {/*          <Typography variant="body2">{keyword.name}</Typography>*/}
      {/*        </Grid>*/}
      {/*        <Grid item>*/}
      {/*          <Typography variant="caption">{keyword.example}</Typography>*/}
      {/*        </Grid>*/}
      {/*      </Grid>*/}
      {/*    </MenuItem>*/}
      {/*    </CopyToClipboard>*/}
      {/*  )}*/}
      {/*</Menu>*/}
    </Fragment>
  );
}

